import {PdfBackend} from "./PdfBackend";

export class MockPdfBackend extends PdfBackend {
    constructor() {
        super();
    }
}